<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ title | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <mat-accordion displayMode="" multi>
      @for (status of statuses; track status) {
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header
          role="button"
          class="mat-row"
          tabindex="0"
          [attr.aria-label]="status.title | globalTranslate"
        >
          <mat-panel-title>
            <h2 class="title">{{ status.title | globalTranslate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="description">
          <ul>
            <li>{{ status.description | globalTranslate }}</li>
          </ul>
        </div>
        <hr />
      </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>